// Hand-authored client for Finkit.Tenants.ApprovalRequests.ApprovalRequestsAppService.
// No generated proxy; routes derived from ABP conventions (confirm at runtime via Network tab):
//   GetForDataTable -> GET  /api/app/approval-requests/for-data-table  (DTO bound from query string)
//   GetPendingCount -> GET  /api/app/approval-requests/pending-count?type=
//   Approve/Reject/ApproveMany/RejectMany -> POST (no verb prefix), id/ids live in the body DTO.
import { http } from '@/api/client/httpClient';
import type { PagedResult } from '@/api/types/abp';
import type {
  ApprovalRequestRowDto,
  ApprovalRequestsInputDto,
  ApprovalRequestType,
  ResolveApprovalRequestDto,
  ResolveManyApprovalRequestsDto,
} from '@/api/types/approvalRequests';

const BASE = '/api/app/approval-requests';

export const approvalRequestsApi = {
  getForDataTable: (input: ApprovalRequestsInputDto) =>
    http
      .get<PagedResult<ApprovalRequestRowDto>>(`${BASE}/for-data-table`, { params: input })
      .then((r) => r.data),

  getPendingCount: (type: ApprovalRequestType) =>
    http.get<number>(`${BASE}/pending-count`, { params: { type } }).then((r) => r.data),

  approve: (input: ResolveApprovalRequestDto) =>
    http.post<void>(`${BASE}/approve`, input).then((r) => r.data),

  reject: (input: ResolveApprovalRequestDto) =>
    http.post<void>(`${BASE}/reject`, input).then((r) => r.data),

  approveMany: (input: ResolveManyApprovalRequestsDto) =>
    http.post<void>(`${BASE}/approve-many`, input).then((r) => r.data),

  rejectMany: (input: ResolveManyApprovalRequestsDto) =>
    http.post<void>(`${BASE}/reject-many`, input).then((r) => r.data),
};
